import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/app/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';
import SearchContext from './Context/SearchContext';
// Side-effect only: registers the axios interceptor that attaches the customer's
// bearer token to PHP/Node calls — see the file for why this lives here instead
// of at each of the ~130 individual call sites.
import './interceptors/customerAuthInterceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
      <Provider store={store}>
        <SearchContext>
          {/* <Router basename="/react"> */}
          <Router>
            <App />
          </Router>
        </SearchContext>
      </Provider>
    </GoogleOAuthProvider>
  </HelmetProvider>,
  // </React.StrictMode>,
);
